import { getPageData } from 'hooks/api';
import useAnimationObserver from 'hooks/useAnimationObserver';
import Head from 'next/head';
import Banner from 'components/global/banner/Banner';
import Accordion from 'components/global/accordion/Accordion';

function FAQs(props) {
  const banner = props?.pageData?.banner;
  const faqs = props?.faqs;

  // FAQ structured data
  const getFAQStructuredData = () => {
    if (!faqs) return null;

    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.attributes.title,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.attributes.text,
        },
      })),
    };

    return JSON.stringify(structuredData);
  };

  // Animations
  useAnimationObserver();

  return (
    <>
      <Head>
        {faqs && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: getFAQStructuredData() }}
            key="faq-jsonld"
          />
        )}
      </Head>

      {banner ? <Banner props={banner} shape="white" /> : null}

      {faqs ? <Accordion items={faqs} /> : null}
    </>
  );
}

export async function getStaticProps() {
  let pageData = await getPageData({
    route: 'faq',
    populate: 'deep',
  });
  pageData = pageData?.data?.attributes || null;

  let faqs = await getPageData({
    route: 'fa-qs-rentals',
    populate: 'deep',
    sort: 'order',
  });
  faqs = faqs?.data || null;

  const seoData = pageData?.seo ?? null;
  if (seoData) {
    seoData.metaTitle = `Rentals ${seoData.metaTitle}`;
  }

  return {
    props: { pageData, faqs, seoData },
  };
}

export default FAQs;
